import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { environment } from 'environments/environment';

// import SecureLS from 'secure-ls';
// var ls = new SecureLS({encodingType: 'base64'});
import ls from 'localstorage-slim';
import { ApiService } from 'app/providers/api.service';
import { AuthService } from 'app/core/auth/auth.service';
import { CustomTranslateService } from '@app/apps/dlr-monitor/services/custom-translate.service';

@Component({
    selector: 'dense-layout',
    templateUrl: './dense.component.html',
    styleUrls: ['./dense.component.scss'],

})
export class DenseLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    navigationAppearance: 'default' | 'dense' = 'dense';
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    clntTntDtls: any;
    tnt_lgo_url_tx: any
    lgimg: boolean = true
    fullimg: boolean = false
    currentLang: string = 'eng'; // Default language


    sbmnuslst: FuseNavigationItem[];
    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = true;
    private _foldersMenuData: FuseNavigationItem[] = [];
    title: any;
    mnunm
    img_data = [];

    shwsbmnu: boolean;
    prnt_mnu_itm_id: any;
    clnt_nm: string = '';
    hd_prmry_nm: any;
    hd_scndry_nm: any;
    PrfieImage: any = ''; //thumnail
    PrfieImage1: any = '';
    usrDtls = {
        dstrt_nm: '',
        ste_nm: '',
        ulb: '',
        hyrchy_hndlr_tx: '',
        rle_nm: ''
    }
    visible: boolean;
    err_msg: string;
    loader: boolean;
    errmsg: boolean;
    content: any;
    sidebarHeadings: string;
    pageDtls: any;
    pagDtlsId: any;
    url: any;

    departments: any[] = [];
    selectedDept: any = null;
    showDeptDropdown: boolean = false;
    routeSub: any;
    all: boolean;
    showMainHeader = true;
 
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private apiSrvc: ApiService,
        private activatedRoute: ActivatedRoute,
        private apisrvc: ApiService,
        private translateService: CustomTranslateService) {
        this.apiSrvc.getSubMnuLst().subscribe(res => {
            console.log(res, "lllllllll")

            if (res && res['children']?.length > 1) {
                this.shwsbmnu = true
                this.sbmnuslst = []
                this.title = res['title']

                this.prnt_mnu_itm_id = res['prnt_mnu_itm_id']
                // res['children'].filter(val=>{
                //     // this.sbmnuslst.push(val);

                //     let obj=val;
                //     // obj['type']='group'
                //     obj['children']=[]
                //     obj['children'].push(val)
                //     this.sbmnuslst.push(obj)

                // })
                this._foldersMenuData = [];
                res['children'].forEach((folder) => {
                    let type = 'group'
                    if (folder['children'] && folder['children'].length > 1) {
                        console.log("length greater", res['children'])
                        const menuItem: FuseNavigationItem = {
                            id: folder.id,
                            title: folder.title,
                            type: 'group',
                            icon: folder.icon,
                            link: folder.link,
                            children: folder['children']
                        };
                        this._foldersMenuData.push(menuItem);

                    }
                    else {
                        console.log("length less", res['children'])
                        const menuItem: FuseNavigationItem = {
                            id: folder.id,
                            title: folder.title,
                            type: 'basic',
                            icon: folder.icon,
                            link: folder.link
                        };
                        this._foldersMenuData.push(menuItem);


                    }
                    // Generate menu item for the folder


                });
                this._updateMenuData();
                console.log(this.sbmnuslst, "kkkkkkkkkkkkkkkkkkkk")
            }
            else {
                this.shwsbmnu = false
            }
        })


        this.apiSrvc.getFeedSideNavTgle().subscribe((res) => {
            console.log(res, "lllllllll");
            if (res) {
                this.navigationAppearance = res;
                if (this.navigationAppearance == 'dense') {
                    this.lgimg = true
                    this.fullimg = false
                }
                if (this.navigationAppearance == 'default') {
                    this.lgimg = false
                    this.fullimg = true
                }
            }
        })

        this.apiSrvc.getShowMainHeader().subscribe((res) => {
            console.log(res, "lllllllll");
            if (res != null) {
                this.showMainHeader = res;
            }
        })

        // this._router.events.pipe(
        //     takeUntil(this._unsubscribeAll),
        //     filter(event => event instanceof NavigationEnd)
        // ).subscribe((event: NavigationEnd) => {
        //     const currentUrl = event.url;
        //     const fullUrl = window.location.href;
        //     const queryParams = this._activatedRoute.snapshot.queryParams;

        //     console.log('URL changed:', {
        //         url: currentUrl,
        //         fullUrl: fullUrl,
        //         queryParams: queryParams
        //     });
        //     // You can perform any actions here based on URL change
        //     this.handleUrlChange(currentUrl);
        // });

        this.apiSrvc.getLgnUsrHyrchyDtls().then((usr_dtls: any) => {
            if (usr_dtls) {
                this.usrDtls = usr_dtls;
                this.usrDtls['rle_nm'] = usr_dtls.roles ? usr_dtls.roles.rle_nm : '';

                console.log(this.usrDtls);
            }
        })

        this.getUserPsitions()
        this.getImgdata()
    }
    private _updateMenuData(): void {
        this.sbmnuslst = [
            {

                title: '',
                type: 'group',
                children: [
                    ...this._foldersMenuData
                ]
            }
        ];
        console.log("MENUUUUUUUUUUUUUUUUUU ", this.sbmnuslst)
    }
    debouncedSearch(e) {

    }
    clearFltr() {

    }

    ngAfterViewInit() {
        this.apiSrvc.getLgnUsrHyrchyDtls().then((usr_dtls: any) => {
            if (usr_dtls) {
                this.usrDtls = usr_dtls;
                this.usrDtls['rle_nm'] = usr_dtls.roles ? usr_dtls.roles.rle_nm : '';

                console.log(this.usrDtls);
            }
        })
    }

    getImgdata() {
        let rte = 'auth/header/images'
        this.apiSrvc.get(rte).subscribe((res) => {
            console.log(res, "kalyaniiiiiiiii")
            if (res && res['status'] == 200) {
                this.img_data = res['data']
                console.log(this.img_data, "kalyanii");
                if (this.img_data && this.img_data.length) {
                    this.img_data.filter((k) => {
                        this.PrfieImage = k['hd_sd_mn_lgo_thmb_nl_url_tx']
                        this.PrfieImage1 = k['hd_sd_mn_lgo_url_tx']
                    });
                    this.ngAfterViewInit()
                }
            }
        })
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Load saved language preference from localStorage if available
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage && (savedLanguage === 'eng' || savedLanguage === 'tel')) {
            this.currentLang = savedLanguage;
            this.translateService.setLanguage(savedLanguage);
            console.log(`Loaded saved language preference: ${savedLanguage}`);
        }

        this.getOriginDtails();
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
        if (ls.get('hms_loggedin_user_clients')) {

            console.log(ls.get('hms_loggedin_user_clients'), "kkkkkkkkkkkkkkkkkkkkkkkkk")

            this.clntTntDtls = JSON.parse(ls.get('hms_loggedin_user_clients'));
            console.log(this.clntTntDtls)
        }

        this.handleUrlChange(this._router.url);

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    /**
     * Toggle the navigation appearance
     */
    toggleNavigationAppearance(): void {
        this.navigationAppearance = (this.navigationAppearance === 'default' ? 'dense' : 'default');
        console.log("navigationAppearance", this.navigationAppearance)

        if (this.navigationAppearance == 'dense') {
            this.lgimg = true
            this.fullimg = false
        }
        if (this.navigationAppearance == 'default') {
            this.lgimg = false
            this.fullimg = true
        }
    }

    onLogoHover(isHovering: boolean) {
        if (isHovering) {
            this.lgimg = false;
            this.fullimg = true;
        } else {
            if (this.navigationAppearance === 'dense') {
                this.lgimg = true;
                this.fullimg = false;
            }
        }
    }

    /**
     * Switch the application language
     * 
     * @param lang The language code ('eng' or 'tel')
     */
    switchLanguage(lang: any): void {
        this.currentLang = lang;
        this.translateService.setLanguage(lang);
        console.log(`Language switched to: ${lang === 'eng' ? 'English' : 'Telugu'}`);
        setTimeout(() => {
            localStorage.setItem('preferredLanguage', lang);
        }, 500);
       
    }

    fter_tx: any = '';
    getOriginDtails(): void {
        this._authService.getUrlBasedbannel()
            .subscribe({
                next: (response) => {
                    console.log(response)
                    if (response && response[`data`].length > 0) {

                        this.fter_tx = response[`data`][0].app_ftr_nm;
                    } else {
                    }
                },
                error: (error) => {
                }
            });
    }


    open(): void {
        // this.visible = true;
        this.sidebarHeadings = "For Help"
        let c = this.activatedRoute.snapshot['_routerState'];
        console.log(c)
        console.log(c.url)
        this.getHtmlContent(c.url)

    }

    getHtmlContent(url) {
        this.content = null;
        let data = {
            url: url
        }
        this.visible = false;
        this.apiSrvc.post(data, 'admin/help_documents').subscribe((res) => {
            this.loader = false;
            this.errmsg = false;
            console.log(res)
            if (res['data'] && res['data'].length) {
                this.content = res['data'][0].pge_chge_tx;
                this.pagDtlsId = res['data'][0].pge_chge_id
                console.log(this.content, 'content')
                this.visible = true;
                this.getpageDtls()
            }
        }, (err) => {
            //   console.log(err);
            this.errmsg = true;
            this.loader = false;
            this.err_msg = "Something went wrong. Please contact the administrator.";
        })
    }

    getpageDtls() {
        let data = {
            pagDtlsId: this.pagDtlsId
        }
        this.apiSrvc.post(data, 'admin/get/pgeDtls/helpdocs').subscribe((res) => {
            console.log(res)
            if (res['status'] == 200) {
                this.pageDtls = res['data'];
                console.log(this.pageDtls, "responseeeeeeee")
                const documentUrls = this.pageDtls.map(item => item.upld_dcmnt_url_tx);
                console.log(documentUrls, "tsssssssssssssfileeeeeeeeeeeeeeee")
            } else {
                // this.alert = {
                //     type: 'error',
                //     message: 'Please check your internet connection and try again'
                // };
            }
        },
            (error) => {
                // alert('er')
                // this.alert = {
                //     type: 'error',
                //     message: 'Please check your internet connection and try again'
                // };
            });
    }
    closeSideBar() {
        this.visible = false
    }
    openDialog(url) {
        console.log(url, "urllllllllllllllll");
        let srvr_url = `${environment.apiOrigin}${url}`;
        // console.log(srvr_url);
        this.apisrvc.shwDocumentViewer(srvr_url);
    }
    getFullImageUrl(url: string): string {
        return `${environment.apiOrigin}${url}`;
    }


    private handleUrlChange(url: string): void {
        // Add your URL change handling logic here
        // For example, update UI, fetch new data, etc. 
        if (url == '/apps/p-task-management/task-dashboard-pannel') {
            this.all = true
            console.log(this.all)
        }
        else {
            this.all = false
            console.log(this.all)
            const currentDept = this.departments.find(d => d.dprt_nm === this.usrDtls['dprt_nm']);
            if (currentDept) {
                this.selectedDept = currentDept;
                this.selectDepartment(currentDept);
            }

        }
    }

    shwPstnSwitchUsr = false;

    getUserPsitions() {
        this.shwPstnSwitchUsr = false;
        this.apiSrvc.get(`task-manager/user/positions`).subscribe((res: any) => {
            console.log(res)
            if (res && res['status'] === 200) {
                this.departments = res['data'];
                // Set the current department as selected
                if (this.departments && this.departments.length > 1) {
                    this.shwPstnSwitchUsr = true;
                }

                if (this.departments && this.departments.length > 0) {
                    const currentDept = this.departments[0];
                    if (currentDept) {
                        this.selectedDept = currentDept;
                        this.selectDepartment(currentDept);
                    }
                }
            }

        })
    }


    toggleDeptDropdown(): void {
        if (this.departments && this.departments?.length && this.departments?.length > 1) {
            this.showDeptDropdown = !this.showDeptDropdown;
        }

    }

    selectDepartment(dept: any): void {
        console.log(this.selectedDept)
        if (dept == 'all') {
            this.selectedDept = {
                dprt_id: 0,
                dprt_nm: 'All Departments',
                pst_nm: 'All'

            };
            let pst_ids = []
            this.departments.filter(val => {
                pst_ids.push(val.pst_id)

            })
            this.apiSrvc.setPositions(pst_ids, 0)
        }
        else {
            this.selectedDept = dept;
            this.apiSrvc.setPositions(dept.pst_id, dept.dprt_id)
        }

        this.showDeptDropdown = false;

        // You can add any additional logic here when a department is selected
        // For example, updating user preferences or triggering other actions
    }


}

